import React from 'react';
import clsx from 'clsx';

import { Content } from './wrappers';

interface IContent {
  children?: React.ReactNode;
  innerHtml?: string;
  limitWidth?: boolean;
  textAlt?: boolean;
  smaller?: boolean;
}

export default ({ children, innerHtml, limitWidth, textAlt, smaller }: IContent) => (
  <Content
    className={clsx(limitWidth && 'limit-width', textAlt && 'text-alt', smaller && 'smaller')}
    dangerouslySetInnerHTML={innerHtml ? { __html: innerHtml } : undefined}>
    {children}
  </Content>
);
